import React, { useState } from "react";
import {
  BannerSectionContainer2,
  BannerSectionWrapper2,
  HeroBannerHighlightGreen,
  HeroBannerTitle,
  RibbionImage,
} from "./styles/components";
import { Box, Typography } from "@mui/material";
import ZipCodeDialog from "./ZipCodeDialog";
import {
  FilterButton,
  PricingFiltersContainer,
  PricingFiltersWrapper,
} from "../landingpagev2/styles/components";
import { usePlanContext } from "./context/planContext";
import EditIcon from "./icons/EditIcon";

const BannerSection2 = () => {
  const {
    setZipCode,
    zipCode,
  } = usePlanContext();
  const [zipDialogOpen, setZipDialogOpen] = useState(false);

  const handleZipCodeClick = () => {
    setZipDialogOpen(true);
  };
  const handleZipCodeClose = () => {
    setZipDialogOpen(false);
  };
  const handleZipCodeSave = (newZipCode: string) => {
    setZipCode(newZipCode);
    setZipDialogOpen(false);
  };

  return (
    <>
      <BannerSectionWrapper2>
        <Box sx={{position: "relative", width: "100%", height: "100%"}}>
          <RibbionImage src="/images/newlandingpage/bgtwrils.png" alt="background" />
        </Box>
        <BannerSectionContainer2>
          <Box sx={{ margin: "50px 0 0 0", textAlign: "center" }}>
            <HeroBannerTitle sx={{ color:"#2372b9"}}>
              Tired of the{" "}
              <HeroBannerHighlightGreen>wild ride?</HeroBannerHighlightGreen>
            </HeroBannerTitle>
            <Typography
              component={"p"}
              sx={{ fontSize: {xs:"12px" ,md:"16px"}, color: "#7f9097f", fontWeight: 500 }}
            >
              See if you can save with a fixed-rate electricity plan
            </Typography>
          </Box>
          <PricingFiltersContainer sx={{marginTop:{xs:"52px", md:"12px"}}}>
            <PricingFiltersWrapper>
              <FilterButton variant="text" onClick={handleZipCodeClick}>
                <Box
                  component="img"
                  src="/images/constenewImg/tdesign_location-filled.svg"
                  alt="Location"
                  sx={{ width: "20px", height: "20px" }}
                />
                Your ZIP: {zipCode}
                <EditIcon size={16} />
              </FilterButton>
            </PricingFiltersWrapper>
          </PricingFiltersContainer>
        </BannerSectionContainer2>
        
          
    
      </BannerSectionWrapper2>
      <ZipCodeDialog
        open={zipDialogOpen}
        zipCode={zipCode}
        onClose={handleZipCodeClose}
        onSave={handleZipCodeSave}
      />
    </>
  );
};

export default BannerSection2;
